<template>
  <div class="app-drawing-zone">
    <div
      class="drawing-container"
      :style="{ width: zoneWidth + 'px', height: height + 'px' }"
    >
      <app-drawing-tool
        :width="zoneWidth"
        :height="height"
        :background-layer="backgroundLayer"
        :drawing.sync="drawing"
        @click-camera="$emit('click-camera')"
        @delete-background="$emit('delete-background')"
        @final-image="$emit('final-image')"
        @save="save"
      />
    </div>
  </div>
</template>

<script>
import AppDrawingTool from "../app-drawing-tool/app-drawing-tool";

export default {
  name: "AppDrawingZone",

  components: {
    AppDrawingTool
  },

  props: {
    height: {
      type: Number,
      default: 850
    },

    aspectRatio: {
      type: Number,
      default: 1.333333333333333
    },

    backgroundLayer: {
      type: String,
      default: ""
    },

    drawing: {
      type: String,
      default: ""
    }
  },

  computed: {
    zoneWidth() {
      return this.height / this.aspectRatio;
    }
  },

  methods: {
    save(data_uri) {
      this.$emit("save", data_uri);
    }
  }
};
</script>

<style lang="scss" scoped>
.app-drawing-zone {
  display: flex;
  justify-content: center;
  height: calc(100% - 100px);
  width: 100%;
  padding-left: 16px;
  padding-right: 16px;

  .drawing-container {
    position: relative;
    border: 1px dashed #eee;
  }
}
</style>
